import { useTranslation } from 'react-i18next'
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog'
import type { Technology } from '@/types/entities'
import { formatDateTime } from '@/lib/dateUtils'

interface TechnologyViewDialogProps {
    open: boolean
    onOpenChange: (open: boolean) => void
    technology: Technology | null
}

export function TechnologyViewDialog({ open, onOpenChange, technology }: TechnologyViewDialogProps) {
    const { t } = useTranslation()
    if (!technology) return null

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-[500px]">
                <DialogHeader>
                    <DialogTitle>{t('technologies.viewTechnology')}</DialogTitle>
                    <DialogDescription>
                        {t('technologies.viewTechnologyDescription')}
                    </DialogDescription>
                </DialogHeader>

                <div className="space-y-4">
                    <div>
                        <label className="text-sm font-medium text-muted-foreground">
                            {t('technologies.manufacturer')}
                        </label>
                        <p className="text-sm mt-1">{technology.manufacturer}</p>
                    </div>

                    <div>
                        <label className="text-sm font-medium text-muted-foreground">
                            {t('technologies.category')}
                        </label>
                        <p className="text-sm mt-1">{technology.category}</p>
                    </div>

                    <div>
                        <label className="text-sm font-medium text-muted-foreground">
                            {t('technologies.model')}
                        </label>
                        <p className="text-sm mt-1">{technology.model}</p>
                    </div>

                    <div>
                        <label className="text-sm font-medium text-muted-foreground">
                            {t('technologies.description')}
                        </label>
                        <p className="text-sm mt-1">{technology.description || '-'}</p>
                        {technology.isSaaS && <p className="text-sm mt-2 font-medium">{t('technologies.isSaaS', 'SaaS: run by its vendor')}</p>}
                    </div>

                    {technology.createdAt && (
                        <div>
                            <label className="text-sm font-medium text-muted-foreground">
                                {t('technologies.createdAt')}
                            </label>
                            <p className="text-sm mt-1">
                                {formatDateTime(technology.createdAt)}
                            </p>
                        </div>
                    )}

                    {technology.updatedAt && (
                        <div>
                            <label className="text-sm font-medium text-muted-foreground">
                                {t('technologies.updatedAt')}
                            </label>
                            <p className="text-sm mt-1">
                                {formatDateTime(technology.updatedAt)}
                            </p>
                        </div>
                    )}
                </div>
            </DialogContent>
        </Dialog>
    )
}
